import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/calendar")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
